import { IStoreModuleState, IState } from "./types";

export const getGDPRState = (state: IStoreModuleState): IState => state.gdpr;
